import { render } from "./BenefitSection.vue?vue&type=template&id=083065bf"
import script from "./BenefitSection.vue?vue&type=script&lang=js"
export * from "./BenefitSection.vue?vue&type=script&lang=js"

import "./BenefitSection.vue?vue&type=style&index=0&id=083065bf&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__